import React, { useState } from 'react'
import MobileResultTab from './MobileResultTab'
import { useBlade } from '../../../services/BladeProvider'
import BladeOpenerModal from '../bladeopener/BladeOpenerModal';
import { RaceDTO } from '../../../interfaces/RaceDTO';
interface Props {
  race:RaceDTO | null;
}
const MobileResultTabs = ({race}:Props) => {

    const {blades} = useBlade();
    const [showModal,setShowModal] = useState(false);
    const tabClicked = (id:number):void => {

    }
    const clickedMenu = (inp:number) => {
     setShowModal(true);
    }
    
  return (
    <>
    {showModal && race ?   <BladeOpenerModal race={race} onExit={() => {setShowModal(false)}} /> : null}
    <div className='mobile-tabs'>
        {blades.map((blad) => {
           return  (<MobileResultTab isadding={false} key={blad.id} text={blad.name} id={blad.id} onClick={tabClicked} />)
        })}
        <MobileResultTab isadding={true} key={-1} text={'\u00A0'} id={-1} onClick={clickedMenu} />
    </div>
    </>
  )
}

export default MobileResultTabs